module.exports = __webpack_public_path__ + "static/img/07无语.bfaf02b.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/im/emoji/07无语.gif
// module id = p0rY
// module chunks = 0